<template>
  <modal 
    v-on:close="closeForm" 
    :show="showModal" 
    modal-id="lineItemModal"
    v-bind:middle="middle"
    headerClasses="justify-content-center">
    <h4 slot="header" class="title title-up">Duplicate Order #{{ this.orderId }}</h4>
    <hr />
    <template v-for="(checkbox, index) in duplicateCheckboxes">
        <base-checkbox
            class="mb-3"
            :key="index"
            v-model="checkbox.checked"
            required
        >
            {{checkbox.name}}
        </base-checkbox>
    </template>
    <template slot="footer">
      <div class="container alert_footer">
        <base-button
          type="danger"
          class="alert_footer_button btn_extra_small btn_info mr-4"
          @click.native="closeForm"
        >
          Cancel
        </base-button>
        <base-button
          type="primary"
          class="alert_footer_button btn_extra_small btn_info"
          @click.native="submit"
        >
          Duplicate
        </base-button>
      </div>
    </template>
  </modal>
</template>

<script>
import axios from "@/axios";
import { BaseButton, Modal } from "@/components";

export default {
name: "duplicate-order-modal",
props: {
  showDuplicateOrderModal: {
    type: Boolean,
    default: false
  },
  orderId: {
    type: String,
    default: 0
  }
},
async mounted(){
  this.closeModal = true;
},
data() {
  return {
    duplicateCheckboxes: [
        {
            "id": 1,
            "name": 'Include Finance Office Information',
            "checked": true
        }, 
        {
            "id": 2,
            "name": 'Include Fund Citations',
            "checked": false
        }
    ],
    middle: true,
    modals: {
      classic: false,
    },
    closeModal: true,
  };
},
components: {
  BaseButton,
  Modal,
},
computed: {
  showModal() {
    this.$validator.reset();
    this.email = ''
    return this.showDuplicateOrderModal || this.modals.classic;
  }
},
methods: {
  closeForm() {
    this.modals.classic = false;
    this.$emit('modal-closed', false);
  },

  submit(e) {
    let data = {
      id: this.orderId,
      financeOffices: this.duplicateCheckboxes[0]['checked'],
      fundCitations: this.duplicateCheckboxes[1]['checked']
    }
    axios.post(`/api/orders/duplicateorder`, data)
        .then((response) => {
          // after update, emit close, and let the parent close the modal,
          // somehow vue router push() combine with the modal disables the scroll bar
          this.$emit('modal-closed', {hasDuplicated: true, orderId: response.data });
        });
  
  }
},
};
</script>

<style lang="scss">
.has-danger .vs__dropdown-toggle {
border-color: #ec250d !important;
}

.error {
color: #ec250d;
font-size: 0.75rem;
}
</style>
